module.exports = __webpack_public_path__ + "static/img/10.5891396.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/sp/10.png
// module id = RjGG
// module chunks = 0